<template>
  <v-tree
    ref="tree"
    :data="nodes"
    :tpl="treeTemplate"
  />
</template>

<script>
import { VTree } from "vue-tree-halower";
import 'vue-tree-halower/dist/halower-tree.min.css';
import _throttle from 'lodash/throttle';

export default {
  name:       "CheckboxTree",
  props:      ['tree', 'value'],
  components: { VTree },
  data() {
    return {
      nodes: null,
    };
  },

  computed: {
    valueMap() {
      if (!Array.isArray(this.value)) return [];
      return this.value.reduce(( dict, v ) => {
        dict[v] = true;
        return dict;
      }, {});
    },
  },

  methods: {
    treeTemplate( node, ctx, parent, index, props ) {
      // console.log(node, ctx, parent, index, props);
      if (node.nocheck) return <span>{node.title}</span>;
      const onChange = ( e ) => {
        const { checked } = e.currentTarget;
        this.checkChildrenNodes(node, checked);
        this.updateNodesChecked();
      };
      return (
        <span class={this.$style.treeRoot}>
          <vs-checkbox value={node.checked} onChange={onChange} disabled={node.disabled}>
            {node.title}
          </vs-checkbox>
        </span>
      );
    },

    parseTree( tree ) {
      return {
        title:       tree.title,
        nocheck:     !tree.selectable,
        chkDisabled: !tree.selectable,
        selDisabled: !tree.selectable,
        checked:     !!this.valueMap[tree.value],
        expanded:    tree.expanded,
        value:       tree.value,
        disabled:    !!tree.disabled,
        children:    Array.isArray(tree.children) ? tree.children.map(this.parseTree) : [],
      };
    },

    checkChildrenNodes( node, checked ) {
      if (!node.disabled) {
        this.$set(node, "checked", checked);
      }
      node.children.forEach(( node ) => {
        this.checkChildrenNodes(node, checked);
      });
    },

    updateNodesChecked( nodes = this.nodes ) {
      nodes.forEach(node => {
        this.updateNodesChecked(node.children);
        if (node.children.length) {
          this.$set(node, "checked", node.children.every(c => c.checked));
        }
      });

      this.emit();
    },

    updateNodes() {
      this.nodes = Array.isArray(this.tree) ? this.tree.map(this.parseTree) : [];
      this.updateNodesChecked();
    },

    getSelectedNodes( nodes = this.nodes, selected = [] ) {
      nodes.forEach(node => {
        const { value, checked, children } = node;
        if (value && checked) selected.push(value);
        this.getSelectedNodes(children, selected);
      });

      return selected;
    },

  },
  mounted() {
    this.emit = _throttle(() => {
      const value = this.getSelectedNodes();
      if (value.toString() !== this.value.toString()) this.$emit('input', value);
    }, 100);

    this.updateNodes();
  },
  watch: {
    tree() {
      this.updateNodes();
    },
    value() {
      this.updateNodes();
    },
  },
};
</script>

<style lang="scss" module>
.treeRoot {
  display: inline-block;
  vertical-align: middle;
}

</style>
